// @flow

const configureTrackJs = (userId: ?string) => {
  if (window.trackJs && userId) {
    window.trackJs.configure({ userId });
  }
};

export default configureTrackJs;
